export const REQUEST_STARTED = 'opportunity_fetch_request_started';
export const REQUEST_SUCCESS = 'opportunity_fetch_request_success';
export const REPLACE_OPPORTUNITY = 'opportunity_replace_opportunity';
